import { GET_IMAGEPORTFOLIOLOGS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_IMAGEPORTFOLIOLOGS:
            return action.payload;
        default:
            return state;
    }
}